// src/data/products.js
export const products = [
    {
        id: 1,
        name: 'Aqua Di Gio - Fresh Aquatic',
        price: 7.79,
        originalPrice: 15.00,
        category: 'designer-inspired',
        family: 'fresh-aquatic',
        image: 'images/product1.jpeg',
        badge: 'sale',
        description: 'A refreshing aquatic fragrance inspired by the Mediterranean. This clean, sophisticated scent combines bergamot, neroli, and sea notes with a subtle musk base.'
    },
    {
        id: 2,
        name: 'Oud Wood - Deep Earthy Powerful',
        price: 9.79,
        originalPrice: 18.00,
        category: 'oud-collection',
        family: 'oud-woody',
        image: 'images/product2.jpeg',
        badge: 'sale',
        description: 'A luxurious oud fragrance featuring rare agarwood, smoky vetiver, and warm amber. This rich, long-lasting perfume oil embodies the essence of Middle Eastern luxury.'
    },
    {
        id: 3,
        name: 'Imagination - Inspired Bold',
        price: 10.79,
        originalPrice: 20.00,
        category: 'designer-inspired',
        family: 'oriental-spicy',
        image: 'images/product3.jpeg',
        badge: 'new',
        description: 'A bold and inspiring fragrance blend that pushes creative boundaries. This unique composition combines citrus top notes with a heart of exotic spices.'
    },
    {
        id: 4,
        name: 'Angel Share - Rich Warm',
        price: 15.79,
        originalPrice: null,
        category: 'exclusive-blends',
        family: 'sweet-gourmand',
        image: 'images/product4.jpeg',
        badge: 'new',
        description: 'A warm and comforting fragrance inspired by the classic gourmand notes. Features rich vanilla, caramel, and cognac accords with a hint of cinnamon.'
    },
    {
        id: 5,
        name: 'Imperial Oud - Royal Blend',
        price: 12.79,
        originalPrice: 22.00,
        category: 'oud-collection',
        family: 'oud-woody',
        image: 'images/product5.jpeg',
        badge: 'sale',
        description: 'An imperial blend of the finest oud oils from around the world. This regal fragrance combines rare agarwood with hints of rose, saffron, and amber.'
    },
    {
        id: 6,
        name: 'Noor Al Oud - Pure Light',
        price: 11.79,
        originalPrice: null,
        category: 'oud-collection',
        family: 'oud-woody',
        image: 'images/product6.jpeg',
        badge: 'sale',
        description: 'A luminous oud fragrance that balances deep woody notes with bright, airy florals. This elegant composition features white musk, jasmine, and rare oud.'
    },
    {
        id: 7,
        name: 'Taif Oud - Floral Oud',
        price: 13.79,
        originalPrice: 24.00,
        category: 'arabic-attars',
        family: 'floral-fresh',
        image: 'images/product1.jpeg',
        badge: 'sale',
        description: 'An exquisite blend of Taif rose and premium oud oil. This luxurious fragrance captures the essence of Arabian nights with its rich floral-woody character.'
    },
    {
        id: 8,
        name: 'Desert Oud - Earthy Rich',
        price: 10.79,
        originalPrice: null,
        category: 'oud-collection',
        family: 'oud-woody',
        image: 'images/product2.jpeg',
        badge: 'sale',
        description: 'A bold and earthy oud fragrance inspired by the Arabian desert. Features intense agarwood, patchouli, and leather notes with a warm amber base.'
    },
    {
        id: 9,
        name: 'Premium Bakhoor Set',
        price: 24.79,
        originalPrice: 35.00,
        category: 'bakhoor-incense',
        family: 'incense-resin',
        image: 'images/product3.jpeg',
        badge: 'new',
        description: 'A premium collection of traditional bakhoor and incense blends. Each piece is handcrafted with the finest ingredients for an authentic Arabian fragrance experience.'
    }
];

export default products;